import axios from 'axios';
import { variables } from "../Variables";

export const updateEventDetailInDB = async (body) => {
    try {
        let url = `${variables.API_URL}LocalEvents/UpdateEventInDatabase`;
        const config = {
            headers: {
                'Content-Type': 'application/json'
            },
        };

        const response = await axios.post(url, body, config);
        return response.data;
        //console.log(response.data);
    } catch (error) {
        console.log("Update event detail:", error);
    }
}

export const isEventTimeAvailableInDB = async (eventSlot) => {

    let increment = 0;
    let currentEventStartDateTime = new Date(eventSlot.startDateTime);
    let currentEventEndDateTime = new Date(eventSlot.endDateTime);

    let estateId = eventSlot.estateId;
    let agentId = eventSlot.agentId;

    let calendarActionId = eventSlot.calendarActionId;

    while (true) {
        /*currentEventStartDateTime = new Date(currentEventStartDateTime.getTime() + increment * 1000);*/
        let formattedStartDateTime = currentEventStartDateTime.toLocaleString('sv-SE').replace(' ', 'T');

        //currentEventEndDateTime = new Date(currentEventEndDateTime.getTime() + increment * 1000);
        let formattedEndDateTime = currentEventEndDateTime.toLocaleString('sv-SE').replace(' ', 'T');

        try {
            let url = `${variables.API_URL}LocalEvents/CheckEventsFromDbBasesOnTime?estateId=${estateId}&calendarActionId=${calendarActionId}&agentId=${agentId}&startDateTime=${formattedStartDateTime}`;

            const response = await axios.get(url);
            //console.log(response.data);

            if (response.data == true) {
                // after first call, only increase by 1 second
                increment = 1;
                currentEventStartDateTime = new Date(currentEventStartDateTime.getTime() + increment * 1000);
                currentEventEndDateTime = new Date(currentEventEndDateTime.getTime() + increment * 1000);

            } else if (response.data == false) {

                const eventDateTime = {
                    startDateTime: formattedStartDateTime,
                    endDateTime: formattedEndDateTime,
                    eventStatus: response.data
                }
                return eventDateTime;
                // break;
            }
        } catch (error) {
            console.log("error:", error);
            break;
        }
    }
}

export const addWhiseCalendarEventService = async (clientToken, body) => {

    try {
        let url = "https://api.whise.eu/v1/calendars/upsert";
        const config = {
            headers: {
                'Authorization': `Bearer ${clientToken}`,
                'Content-Type': 'application/json'
            },
        };
        const response = await axios.post(url, body, config);

        return response.data.calendarId;
    } catch (error) {
        console.log(error);
    }
}

export const checkContactStatusFromWhise = async (clientToken, contactObj) => {
    try {
        let url = "https://api.whise.eu/v1/activities/calendars";

        const config = {
            headers: {
                'Authorization': `Bearer ${clientToken}`,
                'Content-Type': 'application/json'
            },
        };

        const body = {
            "Filter": {
                "ContactId": contactObj.contactId,
                "EstateId": contactObj.estateId
            }
        }

        const response = await axios.post(url, body, config);

        if (response.data) {
            if (response.data.activities != undefined) {
                const foundContactEvent = response.data.activities.find(item =>
                    item.contacts.some(c => c.contactId == contactObj.contactId)
                );

                //console.log(foundContactEvent);
                return foundContactEvent.contacts[0].contactStatus.id;
            } else if (response.data.isValidRequest == true) {
                return response.data.isValidRequest;
            }
        }
    } catch (error) {
        console.log("error", error);
    }
}

export const getContactDetailFromDB = async (contactId) => {
    try {
        let url = `${variables.API_URL}LocalEvents/GetContactDetail?contactId=${contactId}`;
        const config = {
            headers: {
                'Content-Type': 'application/json'
            },
        };

        const response = await axios.get(url, config);
        if (response.data) {
            return response.data;
        }
    } catch (error) {
        console.log("error:", error);
    }
}

export const addNewContactOnWhise = async (clientToken, contactBody) => {
    try {
        let url = "https://api.whise.eu/v1/contacts/upsert";

        const config = {
            headers: {
                'Authorization': `Bearer ${clientToken}`,
                'Content-Type': 'application/json'
            },
        };

        const response = await axios.post(url, contactBody, config);

        if (response.data.contactId) {
            return response.data.contactId;
        }
    } catch (error) {
        console.log("error", error);
    }
}

export const createDummpyEventObj = async (eventDetail, newContactId) => {

    const now = new Date();
    const nextSaturday = new Date(now);

    // Calculate days to Saturday (6 = Saturday)
    const daysToAdd = (6 - now.getDay() + 7) % 7;
    nextSaturday.setDate(now.getDate() + daysToAdd);

    // Set time to 11:00:00 PM
    nextSaturday.setHours(23, 0, 0, 0);

    const startDateTime = nextSaturday.toLocaleString('sv-SE').replace(' ', 'T');

    // End time = start + 1 second
    const endDateTime = new Date(nextSaturday.getTime() + 1000)
        .toLocaleString('sv-SE')
        .replace(' ', 'T');

    const dummpyEventObj = {
        "CalendarActionId": 152841, //"152841",
        "StartDateTime": startDateTime,
        "EndDateTime": endDateTime,
        "AllDay": "false",
        "Private": false,
        "subject": `dumpy event ${eventDetail.ContactIds[0]}`,
        "UserIds": [+eventDetail.UserIds[0]],
        "EstateIds": [+eventDetail.EstateIds[0]], //[estate[0].id],
        "ContactIds": [newContactId != undefined ? newContactId : + eventDetail.ContactIds[0]]
    }

    return dummpyEventObj;
}

export const deletWhiseEventService = async (clientToken, whiseEventId) => {
    let url = "https://api.whise.eu/v1/calendars/delete";
    let headers = {
        'Authorization': `Bearer ${clientToken}`,
        'Content-Type': 'application/json'
    };
    let body = {
        "CalendarIds": [+whiseEventId]
    };
    axios.delete(url, { data: body, headers: headers })
        .then(response => {
            if (response.data) {
                return response.data;
            }
        })
        .catch(error => {
            console.log("error", error)
        });
} 

export const getWhiseCalenderEventByIdService = async (client_Token, eventId) => {
    try {
        let url = "https://api.whise.eu/v1/calendars/list";
        const config = {
            headers: {
                'Authorization': `Bearer ${client_Token}`,
                'Content-Type': 'application/json'
            },
        };
        let body = {
            "Filter": {
                "CalendarIds": [+eventId],
                "IncludeRecurrences": true
            }
        };

        const response = await axios.post(url, body, config);

        if (response.data.calendars) {
            return response.data.calendars;
        }
    } catch (error) {
        console.log("error", error);
    }
}
